import {ContentBlockTypesEnum} from "@/helpers/functions/enum";

export default [
    ContentBlockTypesEnum.IMAGE,
    ContentBlockTypesEnum.TEXT_WITH_IMAGE,
    ContentBlockTypesEnum.TEXT_WITH_TITLE
] as ContentBlockTypesEnum[];
